import { SocketSlice } from "./types"
import { listMembersForWorkspace } from "features/entity-caching/members/UserManagementSlice"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"

export default {
    events: {
        permissionsUpdated: (store) => () => {
            const workspaceId = selectActiveWorkspaceId()(store.getState())
            if (!workspaceId) return
            store.dispatch(listMembersForWorkspace({ workspaceId }))
        },
    },
} as SocketSlice
